import { CONFIGURATION_APIS } from "@/api_framework/api_config";
import { IClinicAvailableParavetsResponse, IParavetDropdownOption } from "@/api_framework/api_modals/Configuration";
import { useConfiguration } from "@/app/hooks/useConfiguration";
import { useAPIUtils } from "@/app/hooks/useAPIUtils";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import axios, { AxiosError } from "axios";
import { useCallback, useState } from "react";
import AxiosCurlirize from "axios-curlirize";

AxiosCurlirize(axios, () => {});

export const useClinicAvailableParavetsAPI = () => {
  const configuration = useConfiguration();
  const { captureError } = useAPIUtils();
  const { sendCurl } = useCurlLogger();
  const [paravetList, setParavetList] = useState<IParavetDropdownOption[]>([]);
  const [attendanceFiltered, setAttendanceFiltered] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const execute = useCallback(
    async (clinicId: string) => {
      if (!clinicId) return;
      setIsLoading(true);
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
        const response = await axios.get<IClinicAvailableParavetsResponse>(
          `${CONFIGURATION_APIS.CLINIC_AVAILABLE_PARAVETS.baseURL}${clinicId}/`,
          {
            headers: {
              Authorization: `${accessToken}`,
              "Content-Type": "application/json",
            },
          },
        );
        setParavetList(response.data?.data?.paravet_list ?? []);
        setAttendanceFiltered(response.data?.data?.attendance_filtered ?? false);
      } catch (error) {
        setParavetList([]);
        setAttendanceFiltered(false);
        if (axios.isAxiosError(error)) {
          const axiosError = error as AxiosError;
          captureError(axiosError);
          if (axiosError.config) {
            sendCurl(axiosError.config["curlCommand"]);
          }
        }
      } finally {
        setIsLoading(false);
      }
    },
    [configuration],
  );

  return { execute, paravetList, attendanceFiltered, isLoading };
};
